import './App.css';
import Posts from './components/Posts';
import Navbar from './components/Navbar';

function App() {
  return (
    <div>
      <Navbar />
      <Posts />
    </div>
  );
}

export default App;

